<template>
    <div>
        <div v-if="data && data.length > 0">
            <div class="row text-h6">
                My {{ typeText }}s & Activations
            </div>
            <p v-if="activateOnly">
                The reactivation of your software {{ typeText | toLowerCase }}(s) can be done at no charge if you change computers or require an operating system re-installation. You may also obtain a secondary activation for your {{ typeText | toLowerCase }}(s) at no charge if both activations are exclusively for your own use.
            </p>
            <p v-else>
                <span v-if="isAnnualSubscriptionsMode">
                    You can renew your annual {{ typeText | toLowerCase }}(s) here. If you choose to renew, the appropriate items will be added to your cart and finalized once you checkout.
                </span>
                <span v-else>
                    You can activate, renew, and upgrade your {{ typeText | toLowerCase }}(s) here. If you choose to renew or upgrade, the appropriate items will be added to your cart and finalized once you checkout.
                </span>
            </p>

            <q-card class="bg-transparent">
                <div class="row full-width">
                    <div class="col">
                        <q-table dense wrap-cells color="primary"
                                 :expanded.sync="expanded"
                                 :loading="getLicensesCustomerPending"
                                 :hide-no-data="getLicensesCustomerPending"
                                 :data="activateOnly ? data.filter(l => l.canActivate) : data" :columns="columns"
                                 :pagination.sync="pagination" row-key="licenseKeyID"
                                 :hide-bottom="(data) ? data.length < pagination.rowsPerPage : false">
                            <template v-slot:header="props">
                                <q-tr :props="props">
                                    <q-th auto-width style="padding: 12px 8px 12px 16px;">Activations</q-th>
                                    <q-th v-for="col in props.cols"
                                          :key="col.name"
                                          :props="props"
                                          style="padding: 12px 8px;">
                                        {{ col.label }}
                                    </q-th>
                                </q-tr>
                            </template>
                            <template v-slot:body="props">
                                <q-tr :props="props" class="q-tr--no-hover">
                                    <q-td auto-width class="text-center">
                                        <q-btn v-if="(props.row.activations.filter(a => a.isCurrent) && props.row.activations.filter(a => a.isCurrent).length > 0)"
                                               color="primary" dense flat @click="props.expand = !props.expand" :icon="props.expand ? 'mdi-menu-up' : 'mdi-menu-down'" />
                                    </q-td>
                                    <q-td v-for="col in props.cols"
                                          :key="col.name"
                                          :props="props"
                                          :auto-width="col.name == 'actions'"
                                          :class="{'cursor-pointer' : col.name !== 'actions' && (props.row.activations.filter(a => a.isCurrent) && props.row.activations.filter(a => a.isCurrent).length > 0)}"
                                          @click="col.name !== 'actions' ? props.expand = !props.expand : ''">
                                        <div v-if="col.name=='orderId'">
                                            <router-link :to="{ name: '/order-details', params: { id: col.value }}"
                                                         class="text-primary">{{ col.value }}</router-link>
                                        </div>
                                        <div v-else-if="col.name == 'actions'" style="min-width: 110px;">
                                            <q-btn v-if="activateOnly && props.row['canActivate']"
                                                   @click="showActivations(props.row)" style="min-width: 108px;"
                                                   size="sm" color="primary" outline icon="mdi-lock-open-variant-outline" label="Activate" />
                                            <btn-license-action-menu :activateOnly="activateOnly" :props="props" :getProductsForPurchaseData="getProductsForPurchaseData"
                                                                     @activate="showActivations" />
                                        </div>
                                        <div v-else-if="col.name=='status'">

                                            <div v-if="isExpired(props.row['expiry'])">
                                                <q-badge transparent color="negative">
                                                    Expired
                                                </q-badge>
                                            </div>

                                            <div v-else>
                                                <q-badge transparent color="positive">
                                                    Active
                                                </q-badge>
                                            </div>
                                        </div>
                                        <div v-else>
                                            {{ col.value }}
                                        </div>
                                    </q-td>
                                </q-tr>
                                <q-tr v-show="props.expand && props.row.activations.filter(a => a.isCurrent).length > 0" :props="props" v-if="props.row.activations.filter(a => a.isCurrent)" class="q-tr--no-hover">
                                    <q-td colspan="100%" style="background-color: #f5f6fa;">
                                        <q-table dense flat square
                                                 hide-header wrap-cells
                                                 style="background-color: #f5f6fa;"
                                                 :data="props.row.activations.filter(a => a.isCurrent)" :columns="columnsActivations" row-key="id"
                                                 :hide-bottom="true">
                                            <template v-slot:body="props">
                                                <q-tr :props="props" class="q-tr--no-hover" style="transition: background-color 2s ease;">
                                                    <q-td class="text-center" style="width: 6%;"></q-td>
                                                    <q-td v-for="col in props.cols"
                                                          :key="col.name"
                                                          :props="props"
                                                          colspan="100%">

                                                        <div v-if="col.name=='actions'">
                                                            <q-btn v-if="data && data.find(l => l.id == props.row.licenseID).canActivate" size="sm" label="Replace" color="warning" icon="mdi-swap-horizontal"
                                                                   style="min-width: 108px;"
                                                                   :loading="currentActivation ? props.row.id == currentActivation.id && (getLicensePending || isMaxActivationsExceededPending) : (getLicensePending || isMaxActivationsExceededPending)"
                                                                   @click="replaceActivation(props.row)" />
                                                        </div>
                                                        <div v-else-if="col.name=='activationCode' && col.value">
                                                            <div class="row items-center">
                                                                <div class="col-auto">
                                                                    <q-btn flat color="primary" size="sm" icon="mdi-content-copy" dense
                                                                           class="q-mr-xs"
                                                                           @click="copyClipboard(col.value)">
                                                                        <q-tooltip>
                                                                            Copy to clipboard
                                                                        </q-tooltip>
                                                                    </q-btn>
                                                                </div>
                                                                <div class="col">
                                                                    <q-field dense :label="col.label" stack-label borderless class="text-caption full-width">
                                                                        <template v-slot:control>
                                                                            {{ col.value }}
                                                                        </template>
                                                                    </q-field>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div v-else-if="col.value">
                                                            <q-field dense :label="col.label" stack-label borderless class="text-caption full-width">
                                                                <template v-slot:control>
                                                                    {{ col.value }}
                                                                </template>
                                                            </q-field>
                                                        </div>
                                                    </q-td>
                                                </q-tr>
                                            </template>
                                        </q-table>
                                    </q-td>
                                </q-tr>
                            </template>

                            <template v-slot:item="props">
                                <div class="col-xs-12 col-sm-6">
                                    <q-card class="full-height">
                                        <q-card-section class="full-height">
                                            <q-item class="row full-height q-pa-none">
                                                <q-item-section class="column justify-between">
                                                    <div>
                                                        <div v-if="isExpired(props.row['expiry'])" class="float-right">
                                                            <q-badge transparent color="negative">
                                                                Expired
                                                            </q-badge>
                                                        </div>

                                                        <div v-else class="float-right">
                                                            <q-badge transparent color="positive">
                                                                Active
                                                            </q-badge>
                                                        </div>
                                                        <div v-for="col in props.cols"
                                                             :key="col.name"
                                                             :props="props">

                                                            <q-field v-if="col.name !== 'status' && col.value"
                                                                     dense :label="col.label" stack-label borderless
                                                                     hide-bottom-space
                                                                     label-color="accent"
                                                                     class="full-width"
                                                                     :class="{'text-caption' : col.name!=='licenseKey'}">
                                                                <template v-slot:control>
                                                                    <span :class="{'text-weight-medium' : col.name=='licenseKey'}">{{ col.value }}</span>
                                                                </template>
                                                            </q-field>
                                                        </div>
                                                    </div>
                                                    <div class="row justify-center q-col-gutter-xs">
                                                        <div class="col-xs-12">
                                                            <q-btn v-if="activateOnly && props.row['canActivate']"
                                                                   @click="showActivations(props.row)"
                                                                   class="full-width"
                                                                   size="sm" color="primary" outline icon="mdi-lock-open-variant-outline" label="Activate" />
                                                            <btn-license-action-menu :activateOnly="activateOnly" :props="props" :getProductsForPurchaseData="getProductsForPurchaseData"
                                                                                     fit @activate="showActivations" class="full-width" />
                                                        </div>
                                                    </div>
                                                </q-item-section>
                                            </q-item>
                                        </q-card-section>
                                    </q-card>
                                </div>
                            </template>
                        </q-table>
                    </div>
                </div>
            </q-card>
        </div>
        <div v-else-if="!(getLicensesCustomerPending || syncCartRenewUpgradePending)">
            <div class="text-h6 row items-center q-mb-sm">
                <q-icon name="mdi-select-off" size="sm" class="q-mr-xs" />No {{ typeText }} Found
            </div>
            <p v-if="productLine">
                A valid {{ productLine.name }} license could not be found for activation. You can purchase a new license on the previous step or at our <router-link :to="{ name:'/store', params: { productLine: productLine.name.toLowerCase()}}">Store</router-link>.
                For further assistance please contact <router-link to="/support/ticket">support</router-link> or call 403.247.8566.
            </p>
        </div>
        <div v-if="getLicensesCustomerPending || syncCartRenewUpgradePending" class="text-center">
            <q-spinner color="primary"
                       :thickness="2"
                       size="3em" />
        </div>
        <dialog-activate :show.sync="showDialogActivate"
                         :activation.sync="currentActivation"
                         :license.sync="currentLicense"
                         @generated="codeGenerated" />

        <dialog-activations :show.sync="showDialogActivations"
                            :license="currentLicense"
                            @activate="activateLicense"
                            @replace="replaceActivation" />

        <q-dialog v-model="showDialogMaxActivationsExceeded" persistent>
            <q-card style="max-width: 450px;" class="full-width">
                <q-card-section>
                    <div class="text-h6 row items-center text-negative">
                        <q-icon name="mdi-cancel" size="sm" class="q-mr-xs" />Max Activations Exceeded
                    </div>
                </q-card-section>
                <q-card-section class="q-pt-none">
                    Sorry, you have exceeded the maximum number of replacement activations allowed at this moment. For further assistance please contact <router-link to="/support/ticket">support</router-link> or call 403.247.8566.
                </q-card-section>
                <q-card-section class="q-pt-none">
                    <div>
                        <q-btn label="Close" color="primary" v-close-popup />
                    </div>
                </q-card-section>
            </q-card>
        </q-dialog>
    </div>
</template>
<script>
    import { date } from 'quasar'
    import { mapState } from 'vuex'
    import dialogActivate from '@/components/dialogs/DialogActivate'
    import dialogActivations from '@/components/dialogs/DialogActivations'
    import btnLicenseActionMenu from '@/components/menus/BtnLicenseActionMenu'

    export default {
        name: 'account-licenses',
        components: {
            dialogActivate,
            dialogActivations,
            btnLicenseActionMenu,
        },
        props: {
            productLine: Object,
            isAnnualSubscriptionsMode: {
                default: false,
                type: Boolean,
            },
            activateOnly: {
                type: Boolean,
                default: false
            },
        },
        data() {
            return {
                expanded: [],
                currentLicense: null,
                currentActivation: null,
                showDialogActivate: false,
                showDialogActivations: false,
                showDialogMaxActivationsExceeded: false,
                pagination: {
                    sortBy: 'desc',
                    descending: false,
                    page: 1,
                    rowsPerPage: 0
                    // rowsNumber: xx if getting data from a server
                },
                columnsActivations: [
                    { name: 'computer', label: 'Computer', align: 'left', field: 'computer', sortable: false, style: 'min-width: 75px; width: 13%;', },
                    { name: 'activationCode', label: 'Activation Code', align: 'left', field: 'activationCode', sortable: false, style: 'width: 28%;' },
                    { name: 'expiry', label: 'Code Expiry', align: 'right', field: 'activationExpiry', sortable: false, style: 'width: 13.5%;', format: (val, row) => (val) ? `${date.formatDate(new Date(val), 'YYYY/MM/DD')}` : '' },
                    { name: 'installId', label: 'Install ID', align: 'left', field: 'installID', sortable: false, style: 'width: 15%;' },
                    //{ name: 'licenseKey', label: 'LicenseKey', align: 'left', field: 'licenseKey', sortable: false },
                    //{ name: 'productId', label: 'ProductID', align: 'left', field: 'productId', sortable: false },
                    { name: 'date', label: 'Date', align: 'right', field: 'dateActivated', sortable: false, style: 'width: 12%;', format: (val, row) => (val) ? `${date.formatDate(new Date(val), 'YYYY/MM/DD')}` : '' },
                    { name: 'actions', label: '', align: 'right', style: 'padding-right: 0px;' },
                ],
                columns: [
                    { name: 'licenseKey', label: 'License Key', align: 'left', field: 'licenseKeyID', sortable: true, style: 'width: 15%;' },
                    { name: 'description', label: 'Product Description', align: 'left', field: 'productDescription', sortable: true, style: 'width: 25%;' },
                    { name: 'oemLocked', label: 'OEM', align: 'left', field: 'oemName', sortable: true, style: 'width: 13%;' },
                    { name: 'expiry', label: 'Expiry', align: 'left', field: 'expiry', sortable: true, style: 'width: 14.5%;', format: (val, row) => (val) ? `${date.formatDate(new Date(val), 'YYYY/MM/DD')}` : '' },
                    { name: 'status', label: 'Subscription', align: 'left', field: 'active', sortable: true, style: 'width: 14%;' },
                    { name: 'actions', label: '', align: 'right' },

                ],
            }
        },
        methods: {
            getLicenses() {
                this.$store.dispatch('getLicensesCustomer', this.user.id).then(() => { })
            },
            codeGenerated(payload) {
                if (payload?.licenseKeyId) this.expanded.push(payload.licenseKeyId)
            },
            replaceActivation(activation) {
                this.currentLicense = null
                this.currentActivation = activation
                this.$store.dispatch('getLicense', this.currentActivation.licenseID).then(() => {
                    this.currentLicense = this.getLicenseData
                    this.$store.dispatch('isMaxActivationsExceeded', this.currentLicense).then(() => {
                        if (this.isMaxActivationsExceededData)
                            this.showDialogMaxActivationsExceeded = true
                        else
                            this.showDialogActivate = true
                    })
                })
            },
            activateLicense(license) {
                this.currentLicense = license
                this.currentActivation = null
                this.showDialogActivate = true
            },
            showActivations(license) {
                this.currentLicense = license
                if (this.currentLicense?.activations?.filter(a => a.isCurrent).length > 0)
                    this.showDialogActivations = true
                else
                    this.activateLicense(license)
            },
            getProductsForPurchase() {
                this.$store.dispatch('getProductsForPurchase', '')
            },

        },
        computed: {
            isLoggedIn() { return this.$store.getters.isLoggedIn },
            user() { return this.$store.getters.authUser },
            ...mapState([
                'getLicensePending',
                'getLicenseData',

                'getLicensesCustomerPending',
                'getLicensesCustomerData',

                'getProductsForPurchasePending',
                'getProductsForPurchaseData',

                'syncCartRenewUpgradePending',
                'syncCartRenewUpgradeData',

                'isMaxActivationsExceededPending',
                'isMaxActivationsExceededData'

            ]),
            data() {
                if (this.getLicensesCustomerData) {
                    if (this.productLine)
                        return this.getLicensesCustomerData?.filter(l => l.active && l.productCategory == this.productLine.name)
                    if (this.isAnnualSubscriptionsMode)
                        return this.getLicensesCustomerData?.filter(l => l.active && l.productCategory == "PlumbingCAD")
                    return this.getLicensesCustomerData?.filter(l => l.active)
                }
                return null
            },
            typeText() {
                if (this.productLine)
                    return this.productLine.isAnnualSubscription ? 'Subscription' : 'License'

                return this.isAnnualSubscriptionsMode ? 'Subscription' : 'License'
            },
            screenSize() {
                return this.$q.screen
            },

        },
        created() {
            this.getLicenses()
            this.getProductsForPurchase()
        },

    }
</script>
<style lang="scss" scoped>

    .q-table--dense .q-table th, .q-table--dense .q-table td {
        padding: 6px 8px;
    }

    .q-table--dense .q-table th:first-child, .q-table--dense .q-table td:first-child {
        padding-left: 16px;
    }

    .q-table--dense .q-table th:last-child, .q-table--dense .q-table td:last-child {
        padding-right: 16px;
    }

</style>
